import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme, getColor } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';
import AvailableReserveLessonSelectBox from '../../../Component/SettingComponent/AvailableReserveLessonSelectBox';
import NewLessonNameInput from '../../../Component/SettingComponent/NewLessonNameInput';
import NewMemberShipValidity from '../../../Component/SettingComponent/NewMemberShipValidity';
import NewPriceSettingInput from '../../../Component/SettingComponent/NewPriceSettingInput';
import AvailableReservePartnerLessonSelectBox from '../../../Component/SettingComponent/AvailableReservePartnerGymLessonSelectBox';
import SubscribeSelectBox from '../../../Component/SettingComponent/SubscribeSelectBox';
import NewMemberShipMaxCountInput from '../../../Component/SettingComponent/NewMembershipMaxCountInput';
import IndexMemberShipMaxCountInput from '../../../Component/SettingComponent/IndexMembershipMaxCountInput';
import { ReactComponent as CheckIconSvg } from '../../../image/Check3.svg';
import {
  parseLessonIds,
  syncAvailableReserveLessonOptions,
  syncPartnerGymAvailableReserveLessonOptions
} from './membershipReserveOptionUtils';

export default function MemberShipEditBox(props) {
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();
  const {
    myStore,
    followStores,
    isClickedMemberShipEdit,
    clickLessonData,
    clickEditMemberShipData,
    lessonData,
    onClickExitAddMemberShipEdit,
    onSaveMemberShip
  } = props;

  const [translateX, setTranslateX] = useState(-1100);

  const [id, setId] = useState(-1);
  const [isMemberShipUnVisible, setIsMemberShipUnVisible] = useState(false);
  const [memberShipName, setMemberShipName] = useState('');

  const [availableLessonData, setAvailableLessonData] = useState([]);
  const [availableLessonIds, setAvailableLessonIds] = useState('');
  const [availableLessonIdList, setAvailableLessonIdList] = useState([]);
  const [availablePartnerGymLessonData, setAvailablePartnerGymLessonData] = useState([]);
  const [availablePartnerGymLessonIds, setAvailablePartnerGymLessonIds] = useState([]);

  const [isValidityUnVisible, setIsValidityUnVisible] = useState(false);
  const [validityUnit, setValidityUnit] = useState({ value: '일' });
  const [validity, setValidity] = useState(0);
  const [isUseSubscribe, setIsUseSubscribe] = useState(0);
  const [isUseIndividualLessonReserveOption, setIsUseIndividualLessonReserveOption] = useState(false);
  const [usePartnerGymIndividualLessonReserveOptions, setUsePartnerGymIndividualLessonReserveOptions] = useState([]);
  const [availableReserveLessonOptions, setAvailableReserveLessonOptions] = useState([]);
  const [partnerGymAvailableReserveLessonOptions, setPartnerGymAvailableReserveLessonOptions] = useState([]);

  const [totalMax, setTotalMax] = useState(0);
  const [weekMax, setWeekMax] = useState(0);
  const [weekCountMax, setWeekCountMax] = useState(0);
  const [dayMax, setDayMax] = useState(0);
  const [availableHold, setAvailableHold] = useState(0);
  const [holdCount, setHoldCount] = useState(0);
  const [isPriceUnVisible, setIsPriceUnVisible] = useState(false);
  const [price, setPrice] = useState(0);

  const TotalMaxRef = useRef();
  const WeekMaxRef = useRef();
  const WeekCountMaxRef = useRef();
  const DayMaxRef = useRef();
  const HoldRef = useRef();
  const HoldCountRef = useRef();
  const AvailablePartnerRef = useRef([]);

  // 회원권 수정 및 추가 클릭시 크기 변화 //
  useEffect(() => {
    if (isClickedMemberShipEdit) setTranslateX(-510);
    else setTranslateX(-1100);
  }, [isClickedMemberShipEdit])

  // 회원권 데이터 세팅 //
  useEffect(() => {
    // 회원권 추가 클릭시 기본 데이터 세팅 //
    if (clickEditMemberShipData === undefined) {
      setId(-1);
      setIsMemberShipUnVisible(true);
      setMemberShipName('');
      setAvailableLessonData([]);
      setAvailableLessonIds('');
      setAvailablePartnerGymLessonData([]);
      setIsValidityUnVisible(false);
      setValidityUnit({ value: '개월' });
      setValidity(0);
      setIsPriceUnVisible(false);
      setPrice(0);
      setIsUseSubscribe(0);
      setIsUseIndividualLessonReserveOption(false);
      setUsePartnerGymIndividualLessonReserveOptions([]);
      setAvailableReserveLessonOptions([]);
      setPartnerGymAvailableReserveLessonOptions([]);

      setTotalMax(-1);
      setWeekMax(-1);
      setWeekCountMax(-1);
      setDayMax(-1);
      setAvailableHold(0);
      setHoldCount(0);
    }
    // 회원권 수정 클릭시 회원권 데이터 세팅 //
    else {
      setId(clickEditMemberShipData.id);
      setIsMemberShipUnVisible(clickEditMemberShipData.isHideAll);
      setMemberShipName(clickEditMemberShipData.name);
      setAvailableLessonIds(clickEditMemberShipData.availableReserveLessonIds);
      setAvailablePartnerGymLessonData(clickEditMemberShipData.partnerGymAvailableLessons);
      setIsValidityUnVisible(clickEditMemberShipData.isHideValidity);

      if (clickEditMemberShipData.validityUnit === 'month') {
        setValidityUnit({ value: '개월' });
        setValidity(clickEditMemberShipData.validity);
      }
      else if (clickEditMemberShipData.validityUnit === 'year') {
        setValidityUnit({ value: '년' });
        setValidity(clickEditMemberShipData.validity);
      }
      else {
        setValidityUnit({ value: '일' });
        setValidity(clickEditMemberShipData.validity);
      }

      setIsPriceUnVisible(clickEditMemberShipData.isHidePrice);
      setPrice(clickEditMemberShipData.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
      setIsUseSubscribe(clickEditMemberShipData.autoPayment);
      setIsUseIndividualLessonReserveOption(clickEditMemberShipData.isUseIndividualLessonReserveOption);
      setUsePartnerGymIndividualLessonReserveOptions(clickEditMemberShipData.usePartnerGymIndividualLessonReserveOptions || []);
      setAvailableReserveLessonOptions(clickEditMemberShipData.availableReserveLessonOptions);
      setPartnerGymAvailableReserveLessonOptions(clickEditMemberShipData.partnerGymAvailableReserveLessonOptions);
      
      setTotalMax(clickEditMemberShipData.totalMax);
      setWeekMax(clickEditMemberShipData.weekMax);
      setWeekCountMax(clickEditMemberShipData.weekCountMax);
      setDayMax(clickEditMemberShipData.dayMax);
      setAvailableHold(clickEditMemberShipData.availableHold);
      setHoldCount(clickEditMemberShipData.holdCount); 

    }
  }, [clickEditMemberShipData])

  // 우리 체육관 예약 가능 수업 키 정리 //
  useEffect(() => {
    setAvailableLessonIdList(parseLessonIds(availableLessonIds));
  }, [availableLessonIds]);

  // 내 체육관 수업 선택 변경 시 수업별 옵션 동기화 //
  useEffect(() => {
    if (availableLessonData === undefined) return;

    setAvailableReserveLessonOptions(prev => syncAvailableReserveLessonOptions(
      prev,
      availableLessonData,
      availableLessonIds,
      myStore.storeId,
      id === -1 ? 0 : id
    ));
  }, [availableLessonData, availableLessonIds, id, myStore.storeId]);

  //  예약 가능 수업 키 정리 //
  useEffect(() => {
    if (availablePartnerGymLessonData === undefined) return;

    setAvailablePartnerGymLessonIds(availablePartnerGymLessonData.map(data => Number(data.followLessonId)));
  }, [availablePartnerGymLessonData]);

  // 파트너 수업 선택 변경 시 수업별 옵션 동기화 //
  useEffect(() => {
    if (availablePartnerGymLessonData === undefined) return;

    setPartnerGymAvailableReserveLessonOptions(prev => syncPartnerGymAvailableReserveLessonOptions(
      prev,
      availablePartnerGymLessonData,
      lessonData,
      myStore.storeId,
      id === -1 ? 0 : id
    ));
  }, [availablePartnerGymLessonData, id, lessonData, myStore.storeId]);

  // 우리 체육관 묶음 옵션 보이기 결정 //
  function decideViewMyStoreTotalReserveOption() {
    let count = isUseIndividualLessonReserveOption ? 1 : 0;

    for (let i = 0; i < usePartnerGymIndividualLessonReserveOptions.length; i++) {
      if (usePartnerGymIndividualLessonReserveOptions[i].isUseIndividualLessonReserveOption) {
        count += 1;
        break;
      }
    }

    return count > 0 && !isUseIndividualLessonReserveOption;
  }

  // 파트너 체육관 묶음 옵션 보이기 결정 //
  function decideViewPartnerGymTotalReserveOption(followStoreId) {
    let count = isUseIndividualLessonReserveOption ? 1 : 0;
    let isUseFollowStoreIndividualLessonReserveOption = false;

    for (let i = 0; i < usePartnerGymIndividualLessonReserveOptions.length; i++) {
      if (usePartnerGymIndividualLessonReserveOptions[i].isUseIndividualLessonReserveOption) count += 1;

      if (usePartnerGymIndividualLessonReserveOptions[i].followStoreId === followStoreId) {
        isUseFollowStoreIndividualLessonReserveOption = usePartnerGymIndividualLessonReserveOptions[i].isUseIndividualLessonReserveOption;
      }
    }

    return count > 0 && !isUseFollowStoreIndividualLessonReserveOption;
  }

  // {t('settingMembership.perClassSettings')} 클릭여부 확인 //
  function decideIsClickedUsePartnerGymIndividualLessonReserveOption(followStoreId) {
    if (usePartnerGymIndividualLessonReserveOptions.length === 0) return false;

    for (let i = 0; i < usePartnerGymIndividualLessonReserveOptions.length; i++) {
      if (usePartnerGymIndividualLessonReserveOptions[i].followStoreId === followStoreId) {
        return usePartnerGymIndividualLessonReserveOptions[i].isUseIndividualLessonReserveOption;
      }
    }
  }

  // 우리 체육관 수업별 예약 설정 보이기 여부 결정 //
  function decideAvailabeReserveOptionButtonView() {
    return availableLessonIdList.length > 0;
  }

  // 파트너 체육관 수업별 예약 설정 보이기 여부 결정 //
  function decidePartnerGymAvailabeReserveOptionButtonView(followStoreId) {
    let availablePartnerGymLessons = availablePartnerGymLessonData.slice();
    
    if (availablePartnerGymLessons.length === 0) return false;
    else {
      let isExist = false;

      for (let i = 0; i < availablePartnerGymLessons.length; i++) {
        if (availablePartnerGymLessons[i].followStoreId === followStoreId) {
          isExist = true;
          break;
        }
      }
      
      return isExist;
    }
  }

  // 파트너 체육관 {t('settingMembership.perClassSettings')} 클릭시 //
  function onClickUsePartnerGymIndividualLessonReserveOption(followStoreId) {
    let useOptions = usePartnerGymIndividualLessonReserveOptions.slice();

    let found = false;
    for (let i = 0; i < useOptions.length; i++) {
      if (useOptions[i].followStoreId === followStoreId) {
        useOptions[i].isUseIndividualLessonReserveOption = !useOptions[i].isUseIndividualLessonReserveOption;
        found = true;
        break;
      }
    }

    if (!found) {
      useOptions.push({
        storeId: myStore.storeId,
        membershipId: id === -1 ? 0 : id,
        followStoreId,
        isUseIndividualLessonReserveOption: true
      });
    }

    setUsePartnerGymIndividualLessonReserveOptions(useOptions);
  }

  // 우리체육관 예약가능 수업 개별옵션 일일사용 가능 횟수 변경시 //
  function onChangeAvailableReserveLessonOptionsDayMax(value, index) {
    let data = availableReserveLessonOptions.slice();

    data[index].dayMax = value;

    setAvailableReserveLessonOptions(data);
  }

  // 우리체육관 예약가능 수업 개별옵션 주간사용 가능 횟수 변경시 //
  function onChangeAvailableReserveLessonOptionsWeekMax(value, index) {
    let data = availableReserveLessonOptions.slice();

    data[index].weekMax = value;

    setAvailableReserveLessonOptions(data);
  }

  // 우리체육관 예약가능 수업 개별옵션 주간이용 일수 변경시 //
  function onChangeAvailableReserveLessonOptionsWeekCountMax(value, index) {
    let data = availableReserveLessonOptions.slice();

    data[index].weekCountMax = value;

    setAvailableReserveLessonOptions(data);
  }

  // 파트너체육관 예약가능 수업 묶음옵션 일일사용 가능 횟수 변경시 //
  function onChangePartnerGymAvailableReserveLessonTotalOptionsDayMax(value, index) {
    let data = usePartnerGymIndividualLessonReserveOptions.slice();

    data[index].dayMax = value;

    setUsePartnerGymIndividualLessonReserveOptions(data);
  }

  // 파트너체육관 예약가능 수업 묶음옵션 주간사용 가능 횟수 변경시 //
  function onChangePartnerGymAvailableReserveLessonTotalOptionsWeekMax(value, index) {
    let data = usePartnerGymIndividualLessonReserveOptions.slice();

    data[index].weekMax = value;

    setUsePartnerGymIndividualLessonReserveOptions(data);
  }

  // 파트너체육관 예약가능 수업 묶음옵션 주간이용 일수 변경시 //
  function onChangePartnerGymAvailableReserveLessonTotalOptionsWeekCountMax(value, index) {
    let data = usePartnerGymIndividualLessonReserveOptions.slice();

    data[index].weekCountMax = value;

    setUsePartnerGymIndividualLessonReserveOptions(data);
  }

  // 파트너체육관 예약가능 수업 개별옵션 일일사용 가능 횟수 변경시 //
  function onChangePartnerGymAvailableReserveLessonIndividualOptionsDayMax(value, index) {
    let data = partnerGymAvailableReserveLessonOptions.slice();

    data[index].dayMax = value;

    setPartnerGymAvailableReserveLessonOptions(data);
  }

  // 파트너체육관 예약가능 수업 개별옵션 주간사용 가능 횟수 변경시 //
  function onChangePartnerGymAvailableReserveLessonIndividualOptionsWeekMax(value, index) {
    let data = partnerGymAvailableReserveLessonOptions.slice();

    data[index].weekMax = value;

    setPartnerGymAvailableReserveLessonOptions(data);
  }

  // 파트너체육관 예약가능 수업 개별옵션 주간이용 일수 변경시 //
  function onChangePartnerGymAvailableReserveLessonIndividualOptionsWeekCountMax(value, index) {
    let data = partnerGymAvailableReserveLessonOptions.slice();

    data[index].weekCountMax = value;

    setPartnerGymAvailableReserveLessonOptions(data);
  }

  // 취소(exit) 클릭시 //
  function onClickCancel() {
    if (TotalMaxRef.current) TotalMaxRef.current.reset(true);
    if (WeekMaxRef.current) WeekMaxRef.current.reset(true);
    if (WeekCountMaxRef.current) WeekCountMaxRef.current.reset(true);
    if (DayMaxRef.current) DayMaxRef.current.reset(true);
    if (HoldRef.current) HoldRef.current.reset(false);
    if (HoldCountRef.current) HoldCountRef.current.reset(false);
    onClickExitAddMemberShipEdit();
  }

  // 저장 클릭시 //
  function onClickSave() {

    let lessonIdList = [];

    availableLessonData.map((newData) => (
      lessonIdList.push(newData.id)
    ))

    let lessonIds = '';

    for (let i = 0; i < lessonIdList.length; i++) {
      if (i === 0) lessonIds += lessonIdList[i];
      else lessonIds += ',' + lessonIdList[i];
    }

    if (lessonIds === '') {
      alert(t('settingMembership.setBookableLesson'));
      return;
    }
    else if (memberShipName === '') {
      alert(t('settingMembership.setMembershipName'));
      return;
    }

    let finalValidityUnit = 'day';
    let finalValidity = validity;

    if (validityUnit.value === '일') finalValidityUnit = 'day';
    else if (validityUnit.value === '개월') finalValidityUnit = 'month';
    else finalValidityUnit = 'year';

    let partnerGymAvailableLessons = [];

    for (let i = 0; i < followStores.length; i++) {
      let lessonData = AvailablePartnerRef.current[i].getValue();

      for (let j = 0; j < lessonData.length; j++) {
        let partnerGymLessonData = {
          followStoreId: lessonData[j].storeId,
          followLessonId: lessonData[j].id
        }

        partnerGymAvailableLessons.push(partnerGymLessonData);
      }
    }


    let requestData = {
      id: id === -1 ? undefined : id,
      lessonId: 0,
      categoryId: clickLessonData.id,
      storeId: 0,
      name: memberShipName,
      price: parseInt(price.toString().replaceAll(',', '')),
      validity: finalValidity,
      validityUnit: finalValidityUnit,
      availableReserveLessonIds: lessonIds,
      totalMax: TotalMaxRef.current.getValue(),
      weekMax: weekMax,
      weekCountMax: weekCountMax,
      dayMax: dayMax,
      availableHold: HoldRef.current.getValue(),
      holdCount: HoldCountRef.current.getValue(),
      autoPayment: isUseSubscribe,
      isHideValidity: isValidityUnVisible,
      isHidePrice: isPriceUnVisible,
      isHideAll: isMemberShipUnVisible,
      partnerGymAvailableLessons: partnerGymAvailableLessons,
      isUseIndividualLessonReserveOption: isUseIndividualLessonReserveOption,
      availableReserveLessonOptions: availableReserveLessonOptions,
      usePartnerGymIndividualLessonReserveOptions: usePartnerGymIndividualLessonReserveOptions,
      partnerGymAvailableReserveLessonOptions: partnerGymAvailableReserveLessonOptions
    }
    let isSuccess = onSaveMemberShip(requestData);

    if (isSuccess) {
      // 저장한 데이터 세팅 초기화 //
      setTimeout(() => {
        setId(-1);
        setIsMemberShipUnVisible(true);
        setMemberShipName('');
        setAvailableLessonData([]);
        setAvailableLessonIds(-1);
        setAvailablePartnerGymLessonData([]);
        setIsValidityUnVisible(false);
        setValidityUnit({ value: '일' });
        setValidity(0);
        setIsPriceUnVisible(false);
        setPrice(0);
        setIsUseSubscribe(0);

        TotalMaxRef.current.reset(true);
        WeekMaxRef.current.reset(true);
        WeekCountMaxRef.current.reset(true);
        DayMaxRef.current.reset(true);
        HoldRef.current.reset(false);
        HoldCountRef.current.reset(false);
      }, 500);
      // 저장한 데이터 세팅 초기화 //
    }
  }

  // 예약가능 수업 텍스트 결정 //
  function onCalcAvailableLessonText(data) {
    if (data === undefined || data.storeName === undefined || data.storeName === '') return t('settingMembership.availableLesson');
    else if (data.partnerId === 0) return t('settingMembership.storeAvailableLesson', { storeName: data.storeName });
    else return t('settingMembership.partnerGymAvailableLesson', { storeName: data.storeName });
  }

  // 예약가능 수업 좌측 로고 결정 //
  function onCalcAvailableLessonStoreLogo(data) {
    if (data === undefined || data.storeName === '') return 'https://picture.link-zone.org/DefaultLogo.png';
    else return data.storeLogo;
  }

  return (
    <TopLevelWrapper translateX={translateX}>
      <InfoView>
        <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{clickEditMemberShipData ? t('settingMembership.editMembership') : t('settingMembership.addMembership')}</Text>
        <ComponentTotalWrapper>
          <ComponentWrapper>
            <ComponentTitleWrapper>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('settingMembership.membershipName')}</Text>
              <UnVisibleWrapper>
                <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('settingMembership.membershipHide')}</Text>
                <UnVisibleCheckBox isClicked={isMemberShipUnVisible} onClick={() => setIsMemberShipUnVisible(!isMemberShipUnVisible)}>
                  {isMemberShipUnVisible && <CheckIcon />}
                </UnVisibleCheckBox>
              </UnVisibleWrapper>
            </ComponentTitleWrapper>
            <NewLessonNameInput value={memberShipName} setValue={setMemberShipName} placeholder={t('settingMembership.membershipNamePlaceholder')} isLeft={true} />
          </ComponentWrapper>
          <ComponentWrapper>
            <ComponentTitleWrapper>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{onCalcAvailableLessonText(myStore)}</Text>
              {
                decideAvailabeReserveOptionButtonView() &&
                <CheckBoxWrapper onClick={() => setIsUseIndividualLessonReserveOption(!isUseIndividualLessonReserveOption)}>
                  <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>{t('settingMembership.perClassSettings')}</Text>
                  <CheckBox isClicked={isUseIndividualLessonReserveOption}>
                    {isUseIndividualLessonReserveOption && <CheckIcon />}
                  </CheckBox>
                </CheckBoxWrapper>
              }
            </ComponentTitleWrapper>
            <AvailableReserveLessonSelectBox
              storeId={myStore.storeId}
              storeLogo={onCalcAvailableLessonStoreLogo(myStore)}
              membershipId={id}
              lessonData={lessonData}
              value={availableLessonData}
              setValue={setAvailableLessonData}
              lessonId={availableLessonIds}
              setLessonId={setAvailableLessonIds} />
          </ComponentWrapper>
          {
            isUseIndividualLessonReserveOption &&
            <IndividualOptionComponentTotalWrapper>
              <ComponentRowWrapper>
                <ComponentLeftWrapper>
                  <ComponentWrapper>
                    <ComponentTitleWrapper>
                      <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('settingMembership.classDays')}</Text>
                      <UnVisibleWrapper>
                        <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('settingMembership.classDaysHide')}</Text>
                        <UnVisibleCheckBox isClicked={isValidityUnVisible} onClick={() => setIsValidityUnVisible(!isValidityUnVisible)}>
                          {isValidityUnVisible && <CheckIcon />}
                        </UnVisibleCheckBox>
                      </UnVisibleWrapper>
                    </ComponentTitleWrapper>
                    <NewMemberShipValidity
                      value={validity}
                      setValue={setValidity}
                      validityUnit={validityUnit}
                      setValidifyUnit={setValidityUnit} />
                  </ComponentWrapper>
                  <ComponentWrapper>
                    <NewMemberShipMaxCountInput ref={HoldRef} dateVal={availableHold} setDateVal={setAvailableHold} explanation={t('settingMembership.maxHoldDays')} unit={t('settingMembership.unitDay')} />
                  </ComponentWrapper>
                </ComponentLeftWrapper>
                <ComponentRightWrapper>
                  <ComponentWrapper>
                    <NewMemberShipMaxCountInput ref={TotalMaxRef} dateVal={totalMax} setDateVal={setTotalMax} explanation={t('settingMembership.totalReserveCount')} unit={t('settingMembership.unitSession')} />
                  </ComponentWrapper>
                  <ComponentWrapper>
                    <NewMemberShipMaxCountInput ref={HoldCountRef} dateVal={holdCount} setDateVal={setHoldCount} explanation={t('settingMembership.holdRequestCount')} unit={t('settingMembership.unitSession')} />
                  </ComponentWrapper>
                </ComponentRightWrapper>
              </ComponentRowWrapper>
              <IndividualOptionComponentWrapper>
                {
                  availableReserveLessonOptions.map((data, index) => (
                    availableLessonIdList.includes(data.lessonId) &&
                    <IndividualOptionWrapper key={'AvailableReserveLessonOptions-' + index}>
                      <OptionLessonTitleWrapper>
                        <LessonNameBox>
                          <ColorTag backgroundColor={getColor(data.color, isDark)}/>
                          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{data.lessonName}</Text>
                        </LessonNameBox>
                      </OptionLessonTitleWrapper>
                      <ComponentRowWrapper>
                        <ComponentWrapper>
                          <IndexMemberShipMaxCountInput index={index} dateVal={data.dayMax} setDateVal={onChangeAvailableReserveLessonOptionsDayMax} explanation={t('settingMembership.dailyUsageSession')} unit={t('settingMembership.unitSession')} isSmall={true} />
                        </ComponentWrapper>
                        <ComponentWrapper>
                          <IndexMemberShipMaxCountInput index={index} dateVal={data.weekMax} setDateVal={onChangeAvailableReserveLessonOptionsWeekMax} explanation={t('settingMembership.weeklyClassSession')} unit={t('settingMembership.unitSession')} isSmall={true} />
                        </ComponentWrapper>
                        <ComponentWrapper>
                          <IndexMemberShipMaxCountInput index={index} dateVal={data.weekCountMax} setDateVal={onChangeAvailableReserveLessonOptionsWeekCountMax} explanation={t('settingMembership.weeklyUsageDays')} unit={t('settingMembership.unitDay')} isSmall={true} />
                        </ComponentWrapper>
                      </ComponentRowWrapper>
                    </IndividualOptionWrapper>
                  ))
                }
              </IndividualOptionComponentWrapper>
              <DivisionLine />
            </IndividualOptionComponentTotalWrapper>
          }
          {
            decideViewMyStoreTotalReserveOption() &&
              <IndividualOptionComponentWrapper>
                    <IndividualOptionWrapper>
                      <ComponentRowWrapper>
                        <ComponentWrapper>
                          <NewMemberShipMaxCountInput ref={DayMaxRef} dateVal={dayMax} setDateVal={setDayMax} explanation={t('settingMembership.dailyUsageSession')} unit={t('settingMembership.unitSession')} />
                        </ComponentWrapper>
                        <ComponentWrapper>
                          <NewMemberShipMaxCountInput ref={WeekMaxRef} dateVal={weekMax} setDateVal={setWeekMax} explanation={t('settingMembership.weeklyClassSession')} unit={t('settingMembership.unitSession')} />
                        </ComponentWrapper>
                        <ComponentWrapper>
                          <NewMemberShipMaxCountInput ref={WeekCountMaxRef} dateVal={weekCountMax} setDateVal={setWeekCountMax} explanation={t('settingMembership.weeklyUsageDays')} unit={t('settingMembership.unitDay')} />
                        </ComponentWrapper>
                      </ComponentRowWrapper>
                    </IndividualOptionWrapper>
                    <DivisionLine />
              </IndividualOptionComponentWrapper>
          }
          {
            followStores.map((data, index) => (
              <IndividualOptionComponentTotalWrapper key={'FollowStore-' + index} style={{ marginTop: '0px' }} >
                <ComponentWrapper >
                  <ComponentTitleWrapper>
                    <GymNameTextWrapper>
                      {(data?.storeName) ? (
                        <>
                          <GymNameEllipsisText>[{data.storeName}]</GymNameEllipsisText>
                          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default' style={{ flexShrink: 0 }}>&nbsp;{t('settingMembership.availableLesson')}</Text>
                        </>
                      ) : (
                        <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('settingMembership.availableLesson')}</Text>
                      )}
                    </GymNameTextWrapper>
                    {
                      decidePartnerGymAvailabeReserveOptionButtonView(data.followStoreId) &&
                      <CheckBoxWrapper onClick={() => onClickUsePartnerGymIndividualLessonReserveOption(data.followStoreId)}>
                        <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>{t('settingMembership.perClassSettings')}</Text>
                        <CheckBox isClicked={decideIsClickedUsePartnerGymIndividualLessonReserveOption(data.followStoreId)}>
                          {decideIsClickedUsePartnerGymIndividualLessonReserveOption(data.followStoreId) && <CheckIcon />}
                        </CheckBox>
                      </CheckBoxWrapper>
                    }
                  </ComponentTitleWrapper>
                  <AvailableReservePartnerLessonSelectBox
                    ref={(el) => (AvailablePartnerRef.current[index] = el)}
                    storeId={data.followStoreId}
                    storeLogo={onCalcAvailableLessonStoreLogo(data)}
                    membershipId={id}
                    lessonData={lessonData}
                    availablePartnerGymLessonData={availablePartnerGymLessonData}
                    setAvailablePartnerGymLessonData={setAvailablePartnerGymLessonData} />
                </ComponentWrapper>
                {
                  decideViewPartnerGymTotalReserveOption(data.followStoreId) &&
                  usePartnerGymIndividualLessonReserveOptions.map((innerData, innerIndex) => (
                    data.followStoreId === innerData.followStoreId &&
                    <IndividualOptionComponentWrapper key={'PartnerGymTotalReserveOption-' + innerIndex} style={{ marginTop: '10px' }}>
                      <IndividualOptionWrapper>
                        <ComponentRowWrapper>
                          <ComponentWrapper>
                            <IndexMemberShipMaxCountInput index={innerIndex} dateVal={innerData.dayMax} setDateVal={onChangePartnerGymAvailableReserveLessonTotalOptionsDayMax} explanation={t('settingMembership.dailyUsageSession')} unit={t('settingMembership.unitSession')} isSmall={true} />
                          </ComponentWrapper>
                          <ComponentWrapper>
                            <IndexMemberShipMaxCountInput index={innerIndex} dateVal={innerData.weekMax} setDateVal={onChangePartnerGymAvailableReserveLessonTotalOptionsWeekMax} explanation={t('settingMembership.weeklyClassSession')} unit={t('settingMembership.unitSession')} isSmall={true} />
                          </ComponentWrapper>
                          <ComponentWrapper>
                            <IndexMemberShipMaxCountInput index={innerIndex} dateVal={innerData.weekCountMax} setDateVal={onChangePartnerGymAvailableReserveLessonTotalOptionsWeekCountMax} explanation={t('settingMembership.weeklyUsageDays')} unit={t('settingMembership.unitDay')} isSmall={true} />
                          </ComponentWrapper>
                        </ComponentRowWrapper>
                      </IndividualOptionWrapper>
                      <DivisionLine />
                    </IndividualOptionComponentWrapper>
                  ))
                }
                {
                  decideIsClickedUsePartnerGymIndividualLessonReserveOption(data.followStoreId) && !decideViewPartnerGymTotalReserveOption(data.followStoreId) &&
                  <IndividualOptionComponentTotalWrapper>
                      <IndividualOptionComponentWrapper>
                        {
                          partnerGymAvailableReserveLessonOptions.map((innerData, innerIndex) => (
                            data.followStoreId === innerData.followStoreId &&
                            availablePartnerGymLessonIds.includes(innerData.lessonId) &&
                            <IndividualOptionWrapper key={'PartnerGymAvailableReserveLessonOptions-' + innerIndex}>
                              <OptionLessonTitleWrapper>
                                <LessonNameBox >
                                  <ColorTag backgroundColor={innerData.color} />
                                  <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{innerData.lessonName}</Text>
                                </LessonNameBox>
                              </OptionLessonTitleWrapper>
                              <ComponentRowWrapper>
                                <ComponentWrapper>
                                  <IndexMemberShipMaxCountInput index={innerIndex} dateVal={innerData.dayMax} setDateVal={onChangePartnerGymAvailableReserveLessonIndividualOptionsDayMax} explanation={t('settingMembership.dailyUsageSession')} unit={t('settingMembership.unitSession')} isSmall={true} />
                                </ComponentWrapper>
                                <ComponentWrapper>
                                  <IndexMemberShipMaxCountInput index={innerIndex} dateVal={innerData.weekMax} setDateVal={onChangePartnerGymAvailableReserveLessonIndividualOptionsWeekMax} explanation={t('settingMembership.weeklyClassSession')} unit={t('settingMembership.unitSession')} isSmall={true} />
                                </ComponentWrapper>
                                <ComponentWrapper>
                                  <IndexMemberShipMaxCountInput index={innerIndex} dateVal={innerData.weekCountMax} setDateVal={onChangePartnerGymAvailableReserveLessonIndividualOptionsWeekCountMax} explanation={t('settingMembership.weeklyUsageDays')} unit={t('settingMembership.unitDay')} isSmall={true} />
                                </ComponentWrapper>
                              </ComponentRowWrapper>
                            </IndividualOptionWrapper>
                          ))
                        }
                      </IndividualOptionComponentWrapper>
                      <DivisionLine />
                  </IndividualOptionComponentTotalWrapper>
                }
              </IndividualOptionComponentTotalWrapper>
            ))
          }
          {
            !isUseIndividualLessonReserveOption &&
            <ComponentRowWrapper>
              <ComponentLeftWrapper>
                <ComponentWrapper>
                  <ComponentTitleWrapper>
                    <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('settingMembership.classDays')}</Text>
                    <UnVisibleWrapper>
                      <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('settingMembership.classDaysHide')}</Text>
                      <UnVisibleCheckBox isClicked={isValidityUnVisible} onClick={() => setIsValidityUnVisible(!isValidityUnVisible)}>
                        {isValidityUnVisible && <CheckIcon />}
                      </UnVisibleCheckBox>
                    </UnVisibleWrapper>
                  </ComponentTitleWrapper>
                  <NewMemberShipValidity
                    value={validity}
                    setValue={setValidity}
                    validityUnit={validityUnit}
                    setValidifyUnit={setValidityUnit} />
                </ComponentWrapper>
              </ComponentLeftWrapper>
              <ComponentRightWrapper>
                <ComponentWrapper>
                  <NewMemberShipMaxCountInput ref={TotalMaxRef} dateVal={totalMax} setDateVal={setTotalMax} explanation={t('settingMembership.totalReserveCount')} unit={t('settingMembership.unitSession')} />
                </ComponentWrapper>
              </ComponentRightWrapper>
            </ComponentRowWrapper>
          }
          {
            (!isUseIndividualLessonReserveOption && !decideViewMyStoreTotalReserveOption()) &&
            <ComponentRowWrapper>
              <ComponentWrapper>
                <NewMemberShipMaxCountInput ref={DayMaxRef} dateVal={dayMax} setDateVal={setDayMax} explanation={t('settingMembership.dailyUsageSession')} unit={t('settingMembership.unitSession')} />
              </ComponentWrapper>
              <ComponentWrapper>
                <NewMemberShipMaxCountInput ref={WeekMaxRef} dateVal={weekMax} setDateVal={setWeekMax} explanation={t('settingMembership.weeklyClassSession')} unit={t('settingMembership.unitSession')} />
              </ComponentWrapper>
              <ComponentWrapper>
                <NewMemberShipMaxCountInput ref={WeekCountMaxRef} dateVal={weekCountMax} setDateVal={setWeekCountMax} explanation={t('settingMembership.weeklyUsageDays')} unit={t('settingMembership.unitDay')} />
              </ComponentWrapper>
            </ComponentRowWrapper>
          }
          {
            !isUseIndividualLessonReserveOption &&
            <ComponentRowWrapper>
              <ComponentLeftWrapper>
                <ComponentWrapper>
                  <NewMemberShipMaxCountInput ref={HoldRef} dateVal={availableHold} setDateVal={setAvailableHold} explanation={t('settingMembership.maxHoldDays')} unit={t('settingMembership.unitDay')} />
                </ComponentWrapper>
              </ComponentLeftWrapper>
              <ComponentRightWrapper>
                <ComponentWrapper>
                  <NewMemberShipMaxCountInput ref={HoldCountRef} dateVal={holdCount} setDateVal={setHoldCount} explanation={t('settingMembership.holdRequestCount')} unit={t('settingMembership.unitSession')} />
                </ComponentWrapper>
              </ComponentRightWrapper>
            </ComponentRowWrapper>
          }
          <ComponentRowWrapper>
            <ComponentLeftWrapper>
              <ComponentWrapper>
                <SubscribeSelectBox isUsePaymentSystem={myStore.isUsePaymentSystem === 'Yes'} isUseSubscribe={isUseSubscribe} setIsUseSubscribe={setIsUseSubscribe} />
              </ComponentWrapper>
            </ComponentLeftWrapper>
            <ComponentRightWrapper>
              <ComponentWrapper>
                <ComponentTitleWrapper>
                  <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('settingMembership.priceSettings')}</Text>
                </ComponentTitleWrapper>
                <NewPriceSettingInput value={price} setValue={setPrice} placeholder={0} />
              </ComponentWrapper>
            </ComponentRightWrapper>
          </ComponentRowWrapper>
        </ComponentTotalWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickCancel}>
            <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('settingMembership.cancel')}</Text>
          </ExitButton>
          <SaveButton onClick={onClickSave}>
            <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='pointer'>{t('settingMembership.save')}</Text>
          </SaveButton>
        </ButtonWrapper>
      </InfoView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 15px 20px;
  margin: 20px;

  box-sizing: border-box;
  min-width: 522px;
  max-width: 522px;
  z-index: 3;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);

  transform: translateX(${props => props.translateX}px);
  transition: all 0.3s ease-in-out;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ComponentTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 14px;

  width: 100%;

  gap: 20px;
`;

const IndividualOptionComponentTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 20px;
`;

const IndividualOptionComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 20px;
`;

const IndividualOptionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10.5px;
`;

const OptionLessonTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const LessonNameBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px 0 0;

  height: 21px;

  gap: 5px;

  border-radius: 3px;
  background-color: ${props => props.theme.buttonFill};
`;

const ColorTag = styled.div`
  width: 10px;
  height: 10px;

  border-radius: 2px;
  background-color: ${props => props.backgroundColor};
`;

const ComponentRowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 25px;

  width: 100%;
`;

const ComponentLeftWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 50%;

  gap: 20px;
`;

const ComponentRightWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 50%;

  gap: 20px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const ComponentTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const GymNameTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  overflow: hidden;
  max-width: 240px;
`;

const GymNameEllipsisText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 5px;

  &:hover {
    cursor: pointer;
  }
`;

const CheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 20px;
  height: 20px;

  border: 1px solid ${props => props.isClicked ? props.theme.primary : props.theme.line};
  border-radius: 3px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const UnVisibleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin: 0 2px 0 0;

  gap: 5px;
`;

const UnVisibleCheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 20px;
  height: 20px;

  border: 1px solid ${props => props.isClicked ? props.theme.primary : props.theme.line};
  border-radius: 3px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const CheckIcon = styled(CheckIconSvg)`
  width: 11px;
  height: 10px;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-end;

  margin-top: 40px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 150px;
  height: 40px;

  border-radius: 6px;
  background-color: ${props => props.theme.primary};

  &:hover {
    cursor: pointer;
  }
`;

const DivisionLine = styled.div`
  margin: 24.5px 0px;

  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};
`;
